import { Link } from "react-router-dom"; // Import Link for navigation
//Props Validations
import PropTypes from "prop-types";

// mui component

// mui icon
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Import ArrowBackIcon
import FiltersHeaderLabel from "components/common/FiltersHeaderLabel";

//import component
import Header from "../components/common/Header";
import Settings from "../components/respondentSettings/Settings";
import FullScreenConatiner from "components/layouts/FullScreenConatiner";

function RespondentSettings({ headerTitle }) {
    return (
        <>
            <Header
                title={headerTitle}
                isStudySelected={false}
                // consumerFilter={consumerFilter}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel />
            </div>

            <FullScreenConatiner
                style={{
                    padding: "20px",
                }}
                subHeight={150}
            >
                <div
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        zIndex: 10,
                    }}
                >
                    <Link to="/studies">
                        {" "}
                        {/* Link to navigate back */}
                        <div
                            className="p-2 liner-light-blue-background color-white"
                            style={{
                                borderRadius: "50%",
                                position: "relative",
                                top: -35,
                                left: -35,
                                cursor: "pointer",
                            }}
                        >
                            <span>
                                {/* <Link to="/studies"> */}
                                <ArrowBackIcon className="color-white" />
                                {/* </Link> */}
                            </span>
                        </div>
                    </Link>
                </div>

                <div>
                    <Settings />
                </div>
            </FullScreenConatiner>
        </>
    );
}
// Typechecking props for the RespondentSettings
RespondentSettings.propTypes = {
    headerTitle: PropTypes.string,
};
export default RespondentSettings;
